import { colors } from "../../../../theme";

export const typeEnum = {
  HEALTHY: 0,
  SICK: 1,
  RECOVERED: 2,
  DEAD: 3
};

export const colorsEnum = {
  0: colors.green,
  1: colors.red,
  2: colors.yellow,
  3: colors.purple
};
export const FPS = 30;
export const UPDATE_INTERVAL = 5;
export const DURATION = 45;
export const SERIES_NBR = (DURATION * FPS) / UPDATE_INTERVAL;
export const RADIUS = 5;
export const SICK_TIME = 12000;
export const AVERAGE_VEL_SETTING = 1;
export const QUARANTINE_WIDTH = 3 * RADIUS;

export const getWallCoords = particleCanvas => [
  particleCanvas.width / 2.0 - QUARANTINE_WIDTH / 2.0,
  particleCanvas.width / 2.0 + QUARANTINE_WIDTH / 2.0
];
